import { Box, Button } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetOneService } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import { HSeparator } from 'shared/components/horizon-ui/separator/Separator';
import Link from 'shared/components/Link';
import Loader from 'shared/components/Loader';


import useGetColors from 'shared/hooks/useGetColors';
import { PathsE, PathsParams } from 'shared/routes';
import Form from './Form';
import PageTitle from 'shared/views/admin/PageTitle';
import { useGetNewsService } from "shared/api/requests/news";
import {
  getUpdateNewsValues,
  UpdateNewsFormT,
  updateNewsResolver,
} from "shared/form-values/news";
import { fillFormErrors } from "../../../utils/devUtils";

const Update = () => {
  const { id, serviceId } = useParams<PathsParams[PathsE.UPDATE_NEWS]>();

  const { t } = useTranslation();
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();

  
  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });
    
  const { useGetOneNews, useUpdateOneNews } = useGetNewsService({
    domain: currentService?.domain,
    token: currentService?.token,
  });

  const { data, isLoading, refetch } = useGetOneNews({
    pathParams: { id },
    params: undefined,
  });

  const { mutate } = useUpdateOneNews({
    pathParams: {id, serviceId},
    params: undefined,
  });


  const methods = useForm<UpdateNewsFormT>({
    defaultValues: getUpdateNewsValues(data),
    resolver: updateNewsResolver,
    mode: "onChange",
  });
  const { formState: { isValid }, trigger } = methods;

  useEffect(() => {
    trigger();
    refetch()
  }, []);


  
  useEffect(() => {
    methods.reset({
      newText: data?.text,
      newUrl: data?.url,
    });
  }, [data])


  const onSubmit: SubmitHandler<UpdateNewsFormT> = (values) => {
    const newValues = {
      ...values,
      newEditTime: new Date().toISOString(),
      newSendTime: new Date().toISOString(),
      newStatus: data?.status,
    };
    console.log('newValues', newValues);
    mutate(newValues, { onError: (error) => fillFormErrors(methods.setError, error) })
  };

  const breadcrumbs = [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
    {
      path: PathsE.GROUPS,
      text: t('services.groups'),
      pathsParams: {
        serviceId,
      },
    },
  ];

  if (isLoading || !data) return <Loader />;

  return (
    <Box>
      <PageTitle
        title={t('services.editNews')}
        breadcrumbs={breadcrumbs}
        backUrl={{
          path: PathsE.GROUPS,
          pathsParams: { serviceId }
        }}
      />
      <Card borderRadius="20px" p="30px">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Form />
            <HSeparator my="20px" mx="-20px" width="calc(100% + 40px)" />
            <Link<PathsParams[PathsE.GROUPS]> path={PathsE.GROUPS} pathsParams={{ serviceId }}>
              <Button
                color={gray800}
                bgColor={gray100}
                borderRadius="8px"
                w="100px"
              >
                {t('buttons.cancel')}
              </Button>
            </Link>
            <Button
              color={white}
              _hover={{
                bgColor: brand400,
              }}
              bgColor={brand500}
              borderRadius="8px"
              ml="20px"
              w="100px"
              type="submit"
              isDisabled={!isValid}
            >
              {t('buttons.edit')}
            </Button>
          </form>
        </FormProvider>
      </Card>
    </Box>
  );
};

export default Update;
